module.exports = __webpack_public_path__ + "static/media/phone.c2d3c5d2.svg";